import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsAntePostEventsWidget" */ './SportsAntePostEventsWidget'),
  modules: ['./SportsAntePostEventsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
